import { calculateCollisionOffsets } from 'components/route-manager/RouteManagerMapV2/utils/calculateCollisionOffsets'

// Container pill footprint in CSS px, taller than a stop pill's 35. Mirrors
// CONTAINER_PILL_CSS_HEIGHT (32 outer + 8 tip + 4 buffer + 6 shadow); duplicated
// as a number so this geometry helper doesn't pull a canvas-touching icon
// generator into every consumer and test that needs an offset.
const CONTAINER_COLLISION_PX = 50

// Stable, meaningful order key (serial / sequence / name digits, then id) so the
// ring doesn't reshuffle when unrelated fields change — mirrors the stop spiderfy.
const getSortKey = marker => {
  const props = (marker && marker.properties) || {}
  const candidate = [props.serialNumber, props.position].find(value => value != null && value !== '')
  if (candidate != null) {
    const num = Number(candidate)
    return Number.isNaN(num) ? `1:${candidate}` : `0:${num.toString().padStart(12, '0')}`
  }
  const name = props.containerName || props.configuredServiceContainerName || ''
  const digits = typeof name === 'string' ? name.match(/(\d+)/) : null
  if (digits) return `0:${digits[1].padStart(12, '0')}`
  return `2:${marker.id || props.id || ''}`
}

/**
 * Rings OVERLAPPING containers out around their own coordinates so stacked
 * containers are each visible. Containers that don't overlap keep their real
 * position, and `baseOffset` <= 0 disables offsetting entirely.
 *
 * Grouping is by on-screen distance at the current zoom, not by coordinate
 * equality: two containers a metre apart occupy the same pixels at street zoom
 * and are what the slider is for, but their coordinate strings differ, so an
 * equality test left the slider doing nothing in the common case. The threshold
 * is the container pill's own footprint, which is taller than a stop pill's.
 */
export const calculateContainerOffsets = (containers = [], baseOffset = 4, { zoom } = {}) =>
  calculateCollisionOffsets(containers, {
    zoom,
    baseOffset,
    collisionPx: CONTAINER_COLLISION_PX,
    sortKey: getSortKey,
  })
